import { defineStore } from 'pinia'
import { ref } from 'vue'
import { appConfigsApi, type AppConfig } from '@/api/app'

/**
 * APP 配置 Store
 * 页面刷新时延迟请求，结果持久化缓存到 localStorage
 */
export const useAppConfigStore = defineStore(
  'appConfig',
  () => {
    const config = ref<AppConfig | null>(null)
    const isLoading = ref(false)

    /**
     * 获取 APP 配置，已有缓存则直接返回，否则发起请求
     */
    async function fetchAppConfig(force = false) {
      if (!force && config.value) return

      if (isLoading.value) return
      isLoading.value = true

      try {
        const response = await appConfigsApi()
        if (response.data) {
          config.value = response.data
        }
      } catch (error) {
        console.error('Failed to fetch app config:', error)
      } finally {
        isLoading.value = false
      }
    }

    /**
     * 强制刷新配置
     */
    function refresh() {
      return fetchAppConfig(true)
    }

    return {
      config,
      isLoading,
      fetchAppConfig,
      refresh,
    }
  },
  {
    persist: true,
  },
)
